import { NgModule } from '@angular/core';
import { CoreJssUtilsModule } from '@core/jss-utils';
import { DefaultComponentModule } from '@innogy/core/modules/components';
import { KnowledgeBaseSharedModule } from '@innogy/knowledge-base/shared';

import { JumbotronContainerComponent } from './jumbotron/jumbotron-container/jumbotron-container.component';
import { JumbotronComponent } from './jumbotron/jumbotron.component';
import { ShareButtonsContainerComponent } from './share-buttons/share-buttons-container/share-buttons-container.component';
import { ShareButtonsComponent } from './share-buttons/share-buttons.component';

@NgModule({
  imports: [
    DefaultComponentModule,
    KnowledgeBaseSharedModule,
    CoreJssUtilsModule,
  ],
  declarations: [
    JumbotronComponent,
    JumbotronContainerComponent,
    ShareButtonsComponent,
    ShareButtonsContainerComponent,
  ],
  exports: [
    JumbotronComponent,
    JumbotronContainerComponent,
    ShareButtonsComponent,
    ShareButtonsContainerComponent,
  ],
})
export class KnowledgeBaseDetailModule {}
